const textValue = (value) => (typeof value === 'string' && value.trim() ? value : undefined);

export const hasUsableDemoQuestionMetadata = (demoQuestionMetadata) => (
  Array.isArray(demoQuestionMetadata?.questionMetadata)
  && demoQuestionMetadata.questionMetadata.length > 0
);

export const hasUsableQuestionMetadata = (questionMetadata) => (
  Array.isArray(questionMetadata)
  && questionMetadata.length > 0
);

const demoQuestionMetadataError = (demoQuestionMetadata) => (
  textValue(demoQuestionMetadata?.questionMetadata?.errMsg)
  || textValue(demoQuestionMetadata?.errMsg)
);

const questionMetadataError = (questionMetadataState) => (
  textValue(questionMetadataState?.questionMetadata?.errMsg)
  || textValue(questionMetadataState?.questionMetadataErrMsg)
  || textValue(questionMetadataState?.errMsg)
);

export const resolveQuestionMetadataError = ({
  isUserAcquisition,
  questionMetadataState,
  demoQuestionMetadata,
  qlinkQuestionMetadata,
}) => {
  if (isUserAcquisition) {
    if (
      hasUsableDemoQuestionMetadata(demoQuestionMetadata)
      || hasUsableQuestionMetadata(qlinkQuestionMetadata)
    ) {
      return undefined;
    }

    return demoQuestionMetadataError(demoQuestionMetadata) || questionMetadataError(questionMetadataState);
  }

  return questionMetadataError(questionMetadataState);
};
